module.exports = __webpack_public_path__ + "static/media/profile.91c22ca7.JPG";